<script lang="ts">
  import logo from '$lib/images/logo.svg';

  import LoginForm from './loginForm.svelte';
  export let data;

  let isLoading: boolean;
</script>

<svelte:head>
  <title>RoastLogger - Login</title>
</svelte:head>

<div class="flex min-h-full items-center justify-center px-4 py-12 sm:px-6 lg:px-8">
  <div class="w-full max-w-md space-y-8">
    <div>
      <img
        class="mx-auto h-20 w-auto"
        class:rl-logo-loading={isLoading}
        src={logo}
        alt="RoastLog"
      />
      <h2 class="mt-6 text-center text-3xl font-bold tracking-tight text-gray-900">
        Sign in to your account
      </h2>
    </div>

    <LoginForm data={data.form} bind:isLoading />
  </div>
</div>

<style>
  .rl-logo-loading {
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotateY(0deg);
    }
    100% {
      transform: rotateY(360deg);
    }
  }
</style>
